import {
  SET_OPEN,
  GET_NOTIFICATIONS,
  GET_NOTIFICATIONS_SUCCESS,
  GET_NOTIFICATIONS_ERROR,
  SET_NOTIFICATIONS_PILOT,

  GET_CURRENT_NOTIFICATION,
  GET_CURRENT_NOTIFICATION_SUCCESS,
  GET_CURRENT_NOTIFICATION_ERROR,
} from './types';

const notificationReducer = (state, action) => {
  switch (action.type) {
    case SET_OPEN:
      return {
        ...state,
        open: action.payload,
      };
    case SET_NOTIFICATIONS_PILOT:
      return {
        ...state,
        pilot: action.payload,
      };
    case GET_CURRENT_NOTIFICATION:
      return {
        ...state,
        current: {
          ...state.current,
          id: action.payload,
          loading: true,
          error: false,
          data: {
            operations: [],
          },
        },
      };
    case GET_CURRENT_NOTIFICATION_SUCCESS:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          error: false,
          data: {
            ...state.current.data,
            ...action.payload,
          },
        },
      };
    case GET_CURRENT_NOTIFICATION_ERROR:
      return {
        ...state,
        current: {
          id: null,
          loading: false,
          error: true,
          data: {
            operations: [],
          },
        },
      };

    case GET_NOTIFICATIONS:
      return {
        ...state,
        notifications: {
          ...state.notifications,
          items: [],
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        notifications: {
          ...state.notifications,
          items: action.payload,
          loading: false,
          error: false,
          success: true,
        },
      };
    case GET_NOTIFICATIONS_ERROR:
      return {
        ...state,
        notifications: {
          ...state.notifications,
          items: [],
          loading: false,
          error: true,
          success: true,
        },
      };
    default:
      return state;
  }
};

export default notificationReducer;
